import {
  WrapItem,
  chakra,
} from "@chakra-ui/react";


const StyledCard = chakra(WrapItem, {
  baseStyle: {
    bg: "gray.100",
    maxWidth: {sm:"100%" , md:'295px'},
    padding: "32px",
    borderRadius: "40px",
    cursor:'pointer',
    width:{base:'100%'}
  },
});

export {
  StyledCard,
};
